export default __webpack_public_path__ + "static/media/logo240.a7351a89.png";